import React, { useState, useEffect } from 'react';
import './ImageSlider.css';
import image1 from '../assets/slider1_refine/slider_1.jpg';
import image2 from '../assets/Finalslider/slider2.jpg';
import image3 from '../assets/Finalslider/slider3.jpg';

const images = [image1, image2, image3];

const ImageSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);



  return (
    <div id="home" className="slider">
      <div
        className="slides"
        style={{
          transform: `translateX(-${currentIndex * 100}%)`,
          transition: 'transform 0.5s ease-in-out',
        }}
      >
        {images.map((image, index) => (
          <div
            key={index}
            className="slide"
            style={{
              backgroundImage: `url(${image})`,
            }}
          />
        ))}
      </div>
      
    </div>
  );
};

export default ImageSlider;
